import { useState } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, IconButton, TextField } from "@mui/material";

const SvgCaptcha = ({ value, onChange, error }) => {
  const [reload, setReload] = useState(0);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  return (
    <>
      <Box display="flex" alignItems="center" gap={2} mb={1}>
        <img
          src={`${BASE_URL}api/captcha?ts=${reload}`}
          alt="captcha"
          height={50}
        />

        <IconButton onClick={() => setReload((r) => r + 1)}>
          <RefreshIcon />
        </IconButton>
      </Box>

      <TextField
        fullWidth
        size="small"
        label="Enter CAPTCHA"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error}
      />
    </>
  );
};

export default SvgCaptcha;
